import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Common from "us.common";
import { DocumentType } from "us.collection.case/constants";
import "./Editor.scss";
import { IEditor } from "../../Interface";
import { Pagination } from "us.common/components";
import {
  getFullContent,
  setHTMLCode,
} from "us.collection.case/components/MessageTemplates/Function";
import { ConnectedProps, connect } from "react-redux";
import { RootState } from "us.helper/types";
import { isEmpty } from "lodash";

const { $Skeleton, $Button, $Popconfirm, $Empty, $Alert } = Common.Components;

const Editor: React.FC<IEditor & PropsFromRedux> = (props) => {
  const { t } = useTranslation();
  const {
    metaData,
    template,
    messageTemplate,
    onClose,
    onExecute,
    onOpenEmail,
    isTemplateExecuting,
  } = props;
  const { plugin } = messageTemplate;
  const { isAddressKnown } = metaData.data ?? {};

  const { isLoading, data } = template ?? {};
  const [currentPage, setCurrentPage] = useState<number>(0);

  const [editTemplateContent, setEditTemplateContent] = useState<Array<any>>(
    data?.messages
  );

  useEffect(() => {
    if (data?.messages) {
      setEditTemplateContent(data?.messages);
      if (document.getElementById("editor")) {
        setHTMLCode(data?.messages[currentPage]);
      }
    }
  }, [data?.messages]);

  /**
   * Page Navigation
   */
  const onNavigation = (toNext: boolean) => {
    try {
      const scrollWrapper = document.getElementById("mteWrapper") as any;
      scrollWrapper.scrollTop = 0;

      const content = getFullContent(editTemplateContent, currentPage);
      if (toNext) {
        setHTMLCode(content[currentPage + 1]);
        setCurrentPage(currentPage + 1);
      } else {
        setHTMLCode(content[currentPage - 1]);
        setCurrentPage(currentPage - 1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <$Skeleton
      className={isLoading ? "p-4" : ""}
      loading={isLoading}
      active
      paragraph={{ rows: 2 }}
    >
      {!isAddressKnown && (
        <$Alert
          message={t(
            "US.COLLECTION.CASE:MASSAGETEMPLATES.DEBTOR_ADDRESS_IS_UNKNOWN"
          )}
          type="info"
          showIcon
          className="mb-3"
        />
      )}
      <div className="message-template-editor" id="ediorId">
        {data?.messages?.length > 0 && (
          <>
            <div className="mte-ieditor">
              <div id="mteWrapper" className="mte-ieditor-body mteib-v2">
                <iframe
                  className="mte-ieditor-iframe"
                  id="editor"
                  height="1130px"
                  width="820"
                />
              </div>
            </div>
            <div className="drawer-footer-fixed align-content-center justify-content-between">
              <Pagination
                dataLength={data?.messages?.length}
                currentPage={currentPage}
                onNavigation={onNavigation}
              />
              <div>
                {plugin?.toLowerCase() === DocumentType.PDF && (
                  <$Popconfirm
                    title={t(
                      "US.COLLECTION.CASE:MASSAGETEMPLATES.EMAILCONFIRM"
                    )}
                    onConfirm={() =>
                      onOpenEmail &&
                      onOpenEmail(
                        getFullContent(editTemplateContent, currentPage)
                      )
                    }
                    okText={t("US.COLLECTION.COMMON:COMMON.YES")}
                    cancelText={t("US.COLLECTION.COMMON:COMMON.NO")}
                  >
                    <$Button className="mr-2" type="primary">
                      {t("US.COLLECTION.CASE:MASSAGETEMPLATES.SEND_EMAIL")}
                    </$Button>
                  </$Popconfirm>
                )}
                <$Popconfirm
                  title={t(
                    "US.COLLECTION.CASE:MASSAGETEMPLATES.EXECUTECONFIRM"
                  )}
                  onConfirm={() =>
                    onExecute &&
                    onExecute(getFullContent(editTemplateContent, currentPage))
                  }
                  okText={t("US.COLLECTION.COMMON:COMMON.YES")}
                  cancelText={t("US.COLLECTION.COMMON:COMMON.NO")}
                  placement="topLeft"
                >
                  <$Button className="mr-2" loading={isTemplateExecuting}>
                    {t("US.COLLECTION.CASE:MASSAGETEMPLATES.EXECUTE")}
                  </$Button>
                </$Popconfirm>
                <$Button onClick={onClose}>
                  {t("US.COLLECTION.COMMON:COMMON.CANCEL")}
                </$Button>
              </div>
            </div>
          </>
        )}
        {isEmpty(data?.messages) && (
          <div className="d-flex justify-content-center">
            <div className="d-flex mt-4">
              <$Empty
                image={$Empty.PRESENTED_IMAGE_SIMPLE}
                description={
                  <span>
                    {t(
                      "US.COLLECTION.CASE:MASSAGETEMPLATES.THERE_IS_NO_TEMPLATE_AVAILABLE"
                    )}
                  </span>
                }
              />
            </div>
          </div>
        )}
      </div>
    </$Skeleton>
  );
};

const mapStateToProps = (state: RootState) => {
  const { domainView } = state;
  const { metaData } = domainView;

  return {
    metaData,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Editor);
